module.exports = __webpack_public_path__ + "static/media/gun-logo-aa-gray.8ef9511c.png";